const submitFile = require('../file/file-server-upload');
let stream = null;
let currentDetail = null;
let img = null;

export function startCamera(detail) {
  if (stream) {
    stopCamera(detail);
  }

  const cameraPage = document.querySelector('.camera-page');
  const cameraDiv = document.querySelector('.camera-div');
  const cameraContent = document.querySelector('.camera-content');
  const videoElement = document.querySelector('.video');
  const canvasElement = document.querySelector('.canvas');
  const button = document.querySelector('#close-camera');

  // Mostrar los elementos necesarios
  cameraPage.classList.remove('dn');
  cameraDiv.classList.remove('dn');
  cameraContent.classList.remove('dn');
  videoElement.classList.remove('dn');
  button.classList.remove('dn');
  canvasElement.classList.add('dn');

  navigator.mediaDevices
    .getUserMedia({ 
      video: { facingMode: "user" }, 
      audio: false 
    })
    .then((mediaStream) => {
      stream = mediaStream;
      videoElement.srcObject = mediaStream;
      return videoElement.play();
    })
    .catch((err) => {
      console.error("Error:", err);
    });
}


export function photo(detail) {
  const cameraContent = document.querySelector('.camera-content');
  const canvasElement = document.querySelector('.canvas');
  const videoElement = document.querySelector('.video');
  const button = document.querySelector('#close-camera');

  canvasElement.classList.remove('dn');
  cameraContent.classList.add('dn');
  videoElement.classList.add('dn');
  button.classList.add('dn');

  if (!stream) return null;

  canvasElement.width = videoElement.videoWidth;
  canvasElement.height = videoElement.videoHeight;
  const ctx = canvasElement.getContext('2d');
  ctx.drawImage(videoElement, 0, 0);

  currentDetail = detail;

  showPreview(canvasElement);
  img = canvasElement;
}


function showPreview(canvas) {
  const previewContainer = document.getElementById('preview-container');
  const previewImage = document.getElementById('preview-image');
  const cameraPage = document.querySelector('.camera-page');

  previewImage.src = canvas.toDataURL('image/jpeg', 0.85);
  
  previewContainer.classList.remove('dn'); // Mostrar la vista previa
}


export function savePreview(detail) {
  const previewContainer = document.getElementById('preview-container');

  convertCanvasToFile(img).then(file => {
    submitFile.triggerSubmitCameraFile(file, currentDetail);
    previewContainer.classList.add('dn');
    stopCamera(currentDetail);
  });
}


export function cancelPreview(detail) {
  const previewContainer = document.getElementById('preview-container');
  previewContainer.classList.add('dn');
  startCamera(currentDetail);
}



function convertCanvasToFile(canvas) {  console.log('convertCanvasToFile')
  const img = new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error('Error al convertir canvas a archivo'));
        return;
      }
      const file = new File([blob], `foto-${Date.now()}.jpg`, {
        type: 'image/jpeg',
        lastModified: Date.now()
      });
      resolve(file);
    }, 'image/jpeg', 0.85);
  });

  console.log('img>', img)
  return img;
}

export function stopCamera(detail) {
  if (stream) {
    stream.getTracks().forEach(track => track.stop());
    stream = null;
  }

  const cameraPage = document.querySelector('.camera-page');
  const cameraDiv = document.querySelector('.camera-div');
  const videoElement = document.querySelector('.video');
  const canvas = document.querySelector('.canvas');

  cameraPage.classList.add('dn');
  cameraDiv.classList.add('dn');
  videoElement.classList.add('dn');
  canvas.classList.add('dn');
}